<script setup lang="ts">
import './assets/style.scss'
import { useModelTable } from './../model/model'
import { VIcons } from '@/shared/ui'
import { AdminMetersButton, AdminMetersDelete, AdminMetersForm } from '@/features/Cabinet'

const store = useModelTable()

store.loadTable()
</script>

<template>
  <VDataTable
    :items="store.meters"
    :headers="store.headers"
    items-per-page="50"
    density="comfortable"
  >
    <template v-slot:item.action="{ item }">
      <div class="flex-table__button">
        <AdminMetersButton :item>
          <VBtn icon density="compact">
            <VIcons type="settings" />
          </VBtn>
        </AdminMetersButton>

        <AdminMetersDelete :item />

        <AdminMetersButton :replace="item.id">
          <VBtn icon density="compact" color="warning">
            <VIcons type="cached" />
          </VBtn>
        </AdminMetersButton>
      </div>
    </template>
  </VDataTable>

  <div class="mt-2 form__btn_left">
    <AdminMetersButton>
      <VBtn>{{ $t('itf.add') }}</VBtn>
    </AdminMetersButton>
  </div>

  <AdminMetersForm :types="store.meterTypes" :meters-count="store.meters.length" />
</template>
